export default {
  trigger: 'Restauranteigenaar uitnodigen',
  title: 'Nodig de restauranteigenaar uit',
  description:
    'Maak een account aan voor de restauranteigenaar. Ze ontvangen een e-mail met een tijdelijk wachtwoord om in te loggen en het instellen van hun restaurant te voltooien.',
  fields: {
    first_name: 'Voornaam',
    last_name: 'Achternaam',
    email: 'E-mail',
  },
  buttons: {
    invite: 'Uitnodiging verzenden',
    cancel: 'Annuleren',
  },
  toasts: {
    invited: '{{email}} is uitgenodigd om het instellen te voltooien.',
    failed: 'Kon het eigenaaraccount niet aanmaken. Probeer het opnieuw.',
  },
};
